<div class="preroll-message {{message_type}}">
  <div class="message message--{{error_type}}">{{message}}</div>
  <div class="description description--{{error_type}}">{% unsafe description.text %}</div>
  {% if description.additional_description %}
    <div class="additional_description additional_description--{{error_type}}">
      {% unsafe description.additional_description %}
    </div>
  {% endif %}
</div>
